import {AfterViewInit, Component, ElementRef, Renderer2} from '@angular/core';
import { ProductNodeComponent } from '../product-node/product-node.component';
import {DetailScreensService} from '../detail-screens-module/services/detail-screens-service';
import {DomService} from '../../../services/dom-service/dom.service';
import {ArrangementLevelComponent} from '../abstract-classes/arrangement-level/arrangement-level.component';
import {ToasterService} from '../../../toaster-module/toaster-service/toaster.service';
import {PopupService} from '../popup-component/popup.service/popup.service';
import {UiHelperService} from '../../../services/shared/helpers/ui-helper.service';

@Component({
  selector: 'app-more-node',
  templateUrl: './more-node.component.html',
  styleUrls: ['../abstract-classes/po-node/ponode.component.css'],
})
export class MoreNodeComponent extends ArrangementLevelComponent implements AfterViewInit {

  parent: ProductNodeComponent | undefined;
  leaf = false;
  override nodeType = 'more-node';
  notExpandable: HTMLElement | undefined | null;

  constructor(domService: DomService, private el: ElementRef, private renderer: Renderer2,
              detailsScreenService: DetailScreensService, toasterService: ToasterService, popupService: PopupService,
              protected override uiHelper: UiHelperService) {
    super(domService, detailsScreenService, toasterService, popupService, uiHelper);
  }

  override onClick() {
    // @ts-ignore
    this.parent.addHiddenChildren(this.children);
    this.renderer.removeChild(this.el.nativeElement.parentElement, this.el.nativeElement);

  }

  ngAfterViewInit() {
    const saldoElem = (this.el.nativeElement as HTMLElement).querySelector('.saldo');
    // @ts-ignore
    this.notExpandable = (this.el.nativeElement as HTMLElement).querySelector('.more-node');
    if (this.notExpandable) {
      // @ts-ignore
      saldoElem.classList.add('more-node-saldo');
    }
  }

}
